// Execution handoff REST client.
//
// The previous version returned "https://snow.example/projects/PRJ001" from its
// catch block, so "Confirm & Create" always reported success with a fabricated
// ServiceNow link and nothing was ever created. Now on the shared client.

import { get, post, demandPath, AI_TIMEOUT_MS } from "../../../api/http";

/**
 * What the handoff will create. Read-only, and works with ServiceNow switched off —
 * the response carries a `servicenow` config block so the UI can show whether a
 * create would actually succeed before anyone presses the button.
 */
export async function getExecutionPreview(demandId) {
  return get(demandPath(demandId, "/execute/preview"));
}

/**
 * Create the objects in the target tool.
 *
 * Throws ApiError on failure. Cases worth handling distinctly in the UI:
 *   409 — TAB has not approved this demand
 *   503 — ServiceNow is unconfigured or USE_REAL_SN is false
 *   501 — the chosen tool is Jira, which has no integration
 *   502 — ServiceNow rejected the call (auth, roles, missing table)
 */
export async function createExecution(demandId, payload) {
  return post(demandPath(demandId, "/execute"), payload, { timeout: AI_TIMEOUT_MS });
}
